import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsJpegComponent } from './simple-icons-jpeg.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsJpegComponent ],
    exports:      [ SimpleIconsJpegComponent ],
    bootstrap:    []
})
export class SimpleIconsJpegModule {}
